import Notification from './user-profile/Notification.vue';
import {routers as NotificationChildrenRouters} from "./user-profile/Notification";

let routers = [
  {
    name: 'user-notification',
    path: '/user-profile/notification',
    component: Notification,
    children: NotificationChildrenRouters,
  }
];

export {routers};